var EqSellModes = {
  SALE: 0,
  LEASING: 1,
  SALE_AND_LEASING: 2,
};

module.exports = EqSellModes;
